import { SystemStyleObject } from '@chakra-ui/styled-system';

import { createContext } from '../../utils/contextUtils';

export const [AdmonitionProvider, useAdmonitionContext] =
  createContext<AdmonitionContext>({
    name: 'AdmonitionContext',
    hookName: 'useAdmonitionContext',
    providerName: '<Admonition />',
  });

export const [AdmonitionStylesProvider, useAdmonitionStyles] = createContext<
  Record<string, SystemStyleObject>
>({
  name: `AdmonitionStylesContext`,
  hookName: `useAdmonitionStyles`,
  providerName: '<Admonition />',
});

export type AdmonitionVariant =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'beta';

export type AdmonitionContext = AdmonitionVariant;
